import {SegmentedControlItem} from '@mantine/core';
import {values} from 'lodash';
import {AnyObject, DropdownOptionItem} from '../types';
import {logger} from '../utils/logger';
import {Env} from '../config/env-vars';
import qs from 'qs';
import {OptionItemDto} from './generated/index.defs';
import {isStringArray} from '../utils/type-guards';

const log = logger('code-gen utils');

type InputObject = {
  [key: string]: string;
};

type KeysMatchingValues<T, U> = {
  [K in keyof T]: K extends keyof U ? string : never;
};

export const getEnumSelectOptions = (() => {
  const enumMapCache = new WeakMap<InputObject, DropdownOptionItem<string>[]>();

  function matchKeysAndValues<
    T extends InputObject,
    U extends KeysMatchingValues<T, U>
  >(enumObject: T, displayMapping?: U) {
    if (!enumObject) {
      throw new Error('invalid enum cache object');
    }

    if (enumMapCache.has(enumObject)) {
      return enumMapCache.get(enumObject) as DropdownOptionItem<string>[];
    }

    log.info('enum cache miss', enumObject);

    const enumOptions: DropdownOptionItem<string>[] = values(enumObject).map((x) => ({
      label: !displayMapping ? x : displayMapping[x],
      value: x,
    }));

    enumMapCache.set(enumObject, enumOptions);
    return enumOptions;
  }

  return matchKeysAndValues;
})();

export const getEnumSegmentedOptions = (() => {
  const enumMapCache = new WeakMap();

  return (enumObject: AnyObject) => {
    if (!enumObject) {
      throw new Error('invalid enum cache object');
    }
    if (enumMapCache.has(enumObject)) {
      return enumMapCache.get(enumObject) as SegmentedControlItem[];
    }

    log.info('enum cache miss', enumObject);
    const enumOptions: SegmentedControlItem[] = values(enumObject).map((x) => ({
      label: x,
      value: x,
    }));

    enumMapCache.set(enumObject, enumOptions);
    return enumOptions;
  };
})();

export function buildApiUrl<T>(url: string, params?: T | AnyObject) {
  const baseUrl = Env.apiBaseUrl;
  const queryString = params
    ? '?' + qs.stringify(params, {allowDots: true})
    : '';
  return `${baseUrl}${url}${queryString}`;
}